import React from "react";
// import Timeline from '@mui/lab/Timeline';
// import TimelineItem from '@mui/lab/TimelineItem';
// import TimelineSeparator from '@mui/lab/TimelineSeparator';
// import TimelineConnector from '@mui/lab/TimelineConnector';
// import TimelineContent from '@mui/lab/TimelineContent';
// import TimelineDot from '@mui/lab/TimelineDot';
// import { Button, Grid, SvgIcon } from "@mui/material";
// import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import { makeStyles } from '@mui/styles';
import {globalTheme} from './Theme'
import ProjectTimelineButton from "./ProjectTimelineButton";
import { Grid } from "@mui/material";

const useStyles = makeStyles((theme) => ({
    grid: {
      padding: "0 5% 0 5%",
      marginBottom: "50px"
    },
  }));


export default function ProjectTimeline(props) {
  const classes = useStyles(globalTheme);

  return (
    <Grid 
      key={props.projectsInfo.title + "_grid"}
      container
      // direction="column"
      justifyContent="center"
      alignItems="center"
      columns={4}
      spacing={2}
      className={classes.grid}
    >
      {
        props.projectsInfo.list.map(
          (project, i, {length}) => (
            <Grid item xs={4} sm={4} md={4} lg={2} key={project[0].key + "_gridItem"} className={classes.gridItem}>
              <ProjectTimelineButton project={project} changeRoute={() => {props.changeRoute(i);}} />
            </Grid>
            // <TimelineItem key={project[0].key + "_timelineItem"}>
            //   <TimelineOppositeContent color="textSecondary">
            //     {/* <Navitem 
            //     buttonClass ={classes.button}
            //     item={project[0].projName} 
            //     tolink={props.projectsInfo.route + "/" + project[0].key} 
            //     onClick={() => {props.scrollToProject(props.projectsInfo, i);}}
            //     /> */}
            //     {/* <SvgIcon>
            //       <Logo />
            //     </SvgIcon> */}
            //     <Button 
            //       className={classes.button}
            //       size='large'
            //       color="secondary"
            //       onClick={() => {props.changeRoute(i);}}>
            //       {project[0].projName}
            //     </Button>
            //     <Grid 
            //       container
            //       direction="row"
            //       justifyContent="flex-end"
            //       className={classes.grid}>
            //       {
            //         project[0].technologies.map(
            //           (technology)=>(
            //             technology.icon != null &&
            //             <div className={classes.iconContainer} key={technology.text}>
            //               <SvgIcon className={classes.svgIcon} key={technology.text + "Icon"}>
            //               {
            //                 technology.icon
            //               }
            //               </SvgIcon>
            //             </div>
            //           )
            //         )
            //       }
            //     </Grid>

            //   </TimelineOppositeContent>
            //   <TimelineSeparator>
            //     <TimelineDot />
            //     {
            //       length-1 !== i ? <TimelineConnector /> : null
            //     }
            //   </TimelineSeparator>
            //   <TimelineContent>
            //     {/* {project[0].technologies.map((technology,i,{length}) => {return (length-1 === i) ? technology : technology + ", " })} */}
            //     {project[0].summary}
            //   </TimelineContent>
            // </TimelineItem>
          )
        )
      }
    </Grid>
  );
}